import React from "react";
import { classNames } from "../../helpers/classNames";

const Checkbox = ({
  checkboxName,
  checkboxInputClass,
  isChecked,
  checkboxClass,
  checkboxLabel,
  checkboxLableClass,
  strike = false,
  checked,
  divClass,
  isDisabled = false,
  onChange = () => { },
  altView = false,
  ...props
}) => {

  return (
    <>
      <div
        className={classNames(
          "relative overflow-hidden flex items-center flex-shrink-0 ",
          divClass
        )}
      >
        <input
          type="checkbox"
          name={checkboxName}
          className={classNames(
            "peer absolute top-0 left-0 w-5 h-5 opacity-0 z-10 cursor-pointer ",
            checkboxInputClass
          )}
          defaultChecked={isChecked}
          checked={checked}
          onChange={onChange}
          isDisabled={isDisabled}
        />
        <div
          className={classNames(
            "w-5 h-5 flex-shrink-0 border  rounded flex items-center justify-center text-sm ",
            altView ?( "bg-chestnut-rose text-white border-chestnut-rose peer-checked:bg-green-500 peer-checked:border-green-500 peer-checked:text-white"):(
              "border-shades-05/50 bg-white text-black/0 peer-checked:bg-chestnut-rose peer-checked:border-chestnut-rose peer-checked:text-white"
            ),
            checkboxClass,
          )}
        >
          {altView ? (
            checked ? <i className="fa-light fa-check"></i> : <i className="fa-light fa-xmark"></i>
          ): (
              <i className="fa-light fa-check"></i>
          )}
          
        </div>
        {checkboxLabel && (
          <div
            className={classNames(
              "text-xs text-gable-green font-normal font-CanelaDeck w-full ml-3 transition-all duration-200",
              strike ? "peer-checked:line-through" : "",
              checkboxLableClass
            )}
          >
            {checkboxLabel}
          </div>
        )}
      </div>
    </>
  );
};

export default Checkbox;
